import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Form } from "react-bootstrap";

// Redux
import { connect } from "react-redux";
import * as actions from "../../redux/actions";

// Component
import Icon from "../Icon";
import Color from "../../assets/color";

class ModalDoNotShow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      doNotShow: false
    };
  }

  _hideModal = () => {
    const { doNotShow } = this.state;
    this.props.onHideHideShopAlert();

    if (!!doNotShow) {
      this.props.onNotShowAlertHideShop();
    }
  };

  _handleOnChange = () => {
    this.setState({
      doNotShow: !this.state.doNotShow
    });
  };

  render() {
    const { hideShopAlertVisible } = this.props;
    const { doNotShow } = this.state;
    return (
      <Modal
        size="xs"
        show={hideShopAlertVisible}
        onHide={this._hideModal}
        centered={true}
        className="modal-do-not-show"
        backdrop="static"
      >
        <div className="inner-container">
          <div className="position-relative text-right">
            <div className="btn-close" onClick={this._hideModal}>
              <Icon
                type="custom"
                name="closecircle"
                color={Color.black}
                size={30}
              />
            </div>
          </div>
          <h3>You can manage don't show list in profile</h3>
          <p>Profile > Don't Show </p>
          <Form.Check
            custom
            type="checkbox"
            className="mb-2"
            id="do-not-show"
            name="do-not-show"
            label="Don't show this message again."
            onChange={() => this._handleOnChange()}
            checked={!!doNotShow}
          />
        </div>
        <Modal.Footer>
          <div className="d-flex">
            <Button
              variant="primary"
              className="ml-auto"
              onClick={() => this._hideModal()}
            >
              Confirm
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModalDoNotShow.propTypes = {
  hideShopAlertVisible: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
  return {
    hideShopAlertVisible: state.App.hideShopAlertVisible
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onHideHideShopAlert: () => dispatch(actions.hideHideShopAlert()),
    onNotShowAlertHideShop: () => dispatch(actions.doNotShowAlertHideShop())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalDoNotShow);
